import axios from "axios";
import { handleGetLocal } from "../../../services/auth-service";
import { setTableData } from "./Data";
import { logOut } from "../../../components/Logout";

export class CloseoutWizardFunction {
  constructor() {
    this.pathname = handleGetLocal("pathURL");
  }
  loadCloseoutWizardData = async (
    navigate,
    setLoading,
    setheaderdata,
    setgridrows,
    setclosestatuses,
    setapproverlist,
    setprogramendreason,
    gPersonId,
    setToastConfig,
    setViewAccess,
    setErrorPopup,
  ) => {
    setLoading(true);
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/close-out-wizard/load-person-close-out?personId=${gPersonId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        console.log("load-person-close-out", val);
        setLoading(false);
        const response = val?.data;
        if (!response?.isSuccess) {
          setErrorPopup({
            isVisible: true,
            message: response?.message || "An error occurred.",
          });
          setViewAccess(false);
          setheaderdata(val?.data?.data?.header);
          return;
        }
        setgridrows(setTableData(val?.data?.data?.grid));
        setheaderdata(val?.data?.data?.header);
        setclosestatuses(val?.data?.data?.closeStatuses);
        setapproverlist(val?.data?.data?.approverList);
        setprogramendreason(val?.data?.data?.programEndReason);
      })
      .catch((val) => {
        setLoading(false);
        if (val?.response?.status === 401) {
          logOut();
        } else {
          if (val?.response?.status) {
            navigate(`/error/500`);
          } else {
            navigate("/error/500");
          }
        }
      });
  };

  submitCloseoutWizardData = async (navigate, setLoading, setToastConfig, toastConfig, data, onSuccess) => {
    setLoading(true);

    await axios
      .post(`${process.env.REACT_APP_API_URL}/api/close-out-wizard/close-out-submit`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        setLoading(false);
        if (val?.data?.success) {
          //   resetFields();
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            message: "Successfully Submitted!",
            type: "success",
          });
          onSuccess?.();
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              message: "Successfully Submitted!",
              type: "success",
            });
          }, 1900);
        } else {
          setToastConfig({
            isVisible: true,
            message: val?.data?.message || "Unable to submit closeout request.",
            type: "error",
          });

          setTimeout(() => {
            setToastConfig({
              isVisible: false,
              message: "",
              type: "",
            });
          }, 3000);
        }
      })
      .catch((val) => {
        setLoading(false);
        if (val?.response?.status === 401) {
          logOut();
        } else {
          if (val?.response?.status) {
            navigate(`/error/500`);
          } else {
            navigate("/error/500");
          }
        }
      });
  };

  approvedByDropdown = async (navigate, setLoading, setapprovedbydropdown) => {
    setLoading(true);
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/obligations/generic-parameter-lookup?parameter=Supervisor`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${this.pathname}`,
        },
      })
      .then((val) => {
        val?.data?.data?.length &&
          setapprovedbydropdown(
            val?.data?.data?.map((val) => {
              return {
                name: val?.value,
                id: val?.id,
              };
            }),
          );
        setLoading(false);
      })
      .catch((val) => {
        setLoading(false);
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        }
      });
  };
}
